/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigBaseResponse extends models.ServiceNowCmdbScopeDetails {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigBaseResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigBaseResponse>): ServiceNowCmdbConfigBaseResponse {
        let obj = Object.assign(new ServiceNowCmdbConfigBaseResponse(), model);
        ServiceNowCmdbConfigBaseResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigBaseResponse>): ServiceNowCmdbConfigBaseResponse {
        if (!model) return null;
        return ServiceNowCmdbConfigBaseResponse.newInstance(<ServiceNowCmdbConfigBaseResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigBaseResponse) {
        if (!obj) return;

        models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigBaseResponse): boolean {
        if (models.ServiceNowCmdbScopeDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigBaseResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
